import { injectable } from "inversify";
import { ValueActionType } from 'features/shared/forms/hooks/useForm';
import IRequirementFormService from "./IRequirementFormService";
import ContractDropdownDTO from "features/contracts/dtos/ContractDropdownDTO";

@injectable()
export default class RequirementFormService implements IRequirementFormService {
  
  isFilledValues(values: Record<string, any>, requiredValues: string[]): boolean {
    for (const value of requiredValues) {
      if (!values[value]) {
        return false;
      }
    }

    return true;
  }

  clearFormValues(formKeys: string[], setFormValue: (key: string, value: any, action: ValueActionType) => void): void {
    for (const key of formKeys) {
      setFormValue(key, null, "remove");
    }
  }

  setDefaultContract(contracts: ContractDropdownDTO[], contractChangeHandler: (contract: ContractDropdownDTO) => void, contractId?: string): void {
    if (contracts.length === 1) {
      contractChangeHandler(contracts[0]);
    }
    if (contracts.length > 0 && contractId) {
      const contract = contracts.find(x => x.contractId === contractId);

      if (contract) {
        contractChangeHandler(contract);
      } 
    }
  }   
}